import * as React from 'react';
import { useNavigate } from 'react-router';

import Button from '@/components/elements/Button/BaseButton';
import { hasDmmLoginCookie, hasDmmLoginCookieInEvenOnce } from '@/lib/auth';
import { getLoginUrl, getSignUpUrl } from '@/lib/dmm/accounts';

const RegisterButton: React.FC = () => {
  const navigate = useNavigate();

  const getButtonLabel = (): string => {
    if (hasDmmLoginCookie()) {
      return 'DMM競輪　利用登録へ進む';
    }
    if (hasDmmLoginCookieInEvenOnce()) {
      return 'ログインして利用登録';
    }
    return 'DMM会員登録はこちら';
  };

  const handleSubmit = () => {
    const dmmLoginPageUrl = hasDmmLoginCookieInEvenOnce()
      ? getLoginUrl('/signup/registration')
      : getSignUpUrl('/signup/registration');

    if (hasDmmLoginCookie()) {
      navigate('/signup/registration');
    } else {
      window.location.href = dmmLoginPageUrl;
    }
  };

  return (
    <Button
      bgColor="primary"
      size="m"
      fontWeight="bold"
      height="56px"
      radius="l"
      onClick={() => handleSubmit()}
    >
      {getButtonLabel()}
    </Button>
  );
};

export default RegisterButton;
